import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

import { type MatchLabelPlaceholders } from './matchPairDisplay';

/**
 * 라벨을 해석할 수 없는 MATCH 항목(이미지 전용/빈 항목)에 쓸 번역 placeholder.
 * 모든 표시 surface 가 동일한 문구를 공유하도록 한 곳에서 제공한다.
 */
export const useMatchLabelPlaceholders = (): MatchLabelPlaceholders => {
  const { t } = useTranslation(['common']);

  return useMemo(
    () => ({
      imageLabel: t('quizMatch.imageItemLabel'),
      fallbackLabel: t('quizMatch.emptyItemLabel'),
    }),
    [t],
  );
};
